'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _image = require('./image.service');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageModule = _angular2.default.module('image.service', []).service('Image', _image2.default).name;

exports.default = imageModule;


// WEBPACK FOOTER //
// ./client/app/services/imageService/image.js